// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__epL7a","title":"styles_title__CYf1d"};